export default "__VITE_ASSET__D3gXUBL0__"